import { Entity } from "../common/decorators/entity.decorator"
import { ApplicantDetails } from "./applicant-details.model"
import { Application } from "./application.model"
import { Contact } from "./contact.model"
import { SchoolReport } from "./schoolReport.model"
import { TrialDayRegistration } from "./trialDay.model"

@Entity('applicant')
export class Applicant {
    id?: string
    email?: string
    emailConfirmed?: boolean
    password?: string
    statusKey?: ApplicantStatusKey
    status?: ApplicantStatus
    dsgvo?: boolean
    registeredAt?: Date
    contacts?: Contact[]
    schoolReport?: SchoolReport
    details?: ApplicantDetails
    applications?: Application[]
    annotation?: string
    trialDayRegistrations?: TrialDayRegistration[]
    anonymizedAt?: Date
}

@Entity('applicantStatus')
export class ApplicantStatus {
    key!: string
    title!: string
    pos!: number
}

export type ApplicantStatusKey = 'created' | 'applied' | 'registered' | 'unregistered' | "accepted" | 'completed'